<template>
    <div class="modal fade" :id="modalId" data-keyboard="false" data-backdrop="static" v-show="showModalFlag">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title text-danger" style="text-transform:uppercase;">{{ title }} </h4>
                    <button type="button" class="close" aria-label="Close" @click="handleOnClose()">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="dialog_content">
                </div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="handleOnClose()">
                        &nbsp;{{ $t('buttons.close') }}
                    </button>
                    <button type="button" class="btn btn-outline-danger pull-right" @click="handleOnSubmit()">
                        &nbsp;{{ confirmLabelButton }}
                    </button>
                </div>
            </div>
        </div>
    </div>

    <!-- Màn hình cảnh báo -->
    <div v-show="showWarning" class="warning-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title text-danger">Cảnh báo</h5>
                    <button type="button" class="close" @click="showWarning = false">
                        <span>&times;</span>
                    </button>
                </div>
                <div class="modal-body" id="dialog_reContent"></div>
                <div class="modal-footer justify-content-between">
                    <button type="button" class="btn btn-outline-dark pull-left" @click="showWarning = false"> &nbsp;{{ $t('buttons.close') }} </button>
                    <button type="button" class="btn btn-outline-danger pull-right" :disabled="confirmDisabled" @click="confirmSubmit()">Xác nhận <span v-if="confirmDisabled">({{ countdown }})</span></button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
export default {
    name: "TheConfirmDialogModal",
    props: {
        title: String,
        confirmLabelButton: String,
        onClose: Function,
        onSubmit: Function,
        modalContent: String,
        idModal: String,
        showModalFlag: {
            type: Boolean,
            default: false,
        },

        isReConfirm: {
            require: false,
            type: Boolean,
            default: false
        },

        reConfirmMes: {
            require: false,
            type: String,
            default: "Bạn có chắc chắn muốn thực hiện hành động này không?",
        }


    },
    data() {
        return {
            modalId: this.idModal || '_' + Math.random().toString(36).substr(2, 9),
            showWarning: false, // Kiểm soát hiển thị cảnh báo
            confirmDisabled: true, // Vô hiệu hóa nút "Xác nhận lần 2"
            countdown: 5, // Số giây đếm ngược
        };
    },
    methods: {
        showModal() {
            this.$emit('update:showModalFlag', true);
            $('#' + this.modalId).modal('show');
        },
        closeModal() {
            this.$emit('update:showModalFlag', false);
            $('#' + this.modalId).modal('hide');
        },
        handleOnClose() {
            if (this.onClose) {
                this.onClose();
            } else {
                this.closeModal();
            }
        },
        handleOnSubmit() {
            if(this.isReConfirm)
            {
                this.showWarning = true;
                this.confirmDisabled = true; // Vô hiệu hóa nút ban đầu
                this.countdown = 5; // Reset bộ đếm

                // Bắt đầu đếm ngược
                let interval = setInterval(() => {
                    if (this.countdown > 1) {
                        this.countdown--;
                    } else {
                        this.confirmDisabled = false;
                        clearInterval(interval); // Dừng khi hết thời gian
                    }
                }, 1000);
            }
            else this.confirmSubmit()
        },
        confirmSubmit() {
            this.showWarning = false;
            if (this.onSubmit) {
                this.onSubmit();
            }
            this.closeModal();
        }
    },
    watch: {
        modalContent(newContent) {
            let contentDiv = document.getElementById('dialog_content');
            contentDiv.innerHTML = newContent || '';
        },

        reConfirmMes(newContent) {
            let contentDiv = document.getElementById('dialog_reContent');
            contentDiv.innerHTML = newContent || '';
        },
        showModalFlag(newVal) {
            if (newVal) {
                this.showModal();
            } else {
                this.closeModal();
            }
        },
    },
};
</script>

<style>
/* Cải thiện hiển thị modal cảnh báo */
.warning-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1050; /* Đặt cao hơn Bootstrap modal */
}
</style>